<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Store Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         
         return {
            title: "Store Orders",
            items: [
               {
                  text: "Store Orders",
                  active: true,
               },                   
            ],
             assign_delivery_boy: {
               order_id: '',
               delivery_boy_id: ''
            },
             delivery_boys: [],

            orders: [],            
            
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
            from: null,
            to: null,
            total: null,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchOrders();

      },
      methods: {
         fetchOrders(page_url = null) {

         let url = "store/orders/store?keyword="  + this.keyword + "&limit=" + this.listing_length+ "&status=" + this.status;         
         this.getToken();
         page_url = page_url || url;

         if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
         } 

         this.active_page_url = page_url;
         this.loading = true;


         this.$axios
         .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            if(res.status == 200) {

            var responseData = res.data.data;
            console.log(responseData);
            if(responseData.orders){
            this.orders = responseData.orders.data; 
            this.pagination = responseData.orders.links;
            this.from = responseData.orders.from;
            this.to = responseData.orders.to;
            this.total = responseData.orders.total;
            }

            }
                  
         })
         .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
            if(error.response.status == 422) {               
               if (error.response.data) {
                  this.errors = error.response.data.message;
               } 
               this.$swal("", error.response.statusText, "error");
               
            } else if(error.response.status == 500) {
               this.$swal("", error.response.statusText, "error");
            } 
            else if(error.response.status == 401) {
               this.$swal("", error.response.statusText, "error");
               this.$router.push({ name: "login" });
            } else {
               this.$swal("", "Something went wrong", "error");
            }
         } else {
            this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         },
         getToken() {
            if (localStorage.getItem('sigofish_store')) {
               var sigofish_store =  JSON.parse(localStorage.getItem('sigofish_store'));
               if(sigofish_store.token) {
                  this.token = sigofish_store.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
            }, 


showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },    

        
         fetchDeliveryBoys(order) {

                                    this.assign_delivery_boy.order_id = order.id;

            let url = "store/delivery_boys";  
         this.getToken();

            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.delivery_boys = responseData.delivery_boys;
                  this.showModal('assign-modal');
            })
            .catch((err) => console.log(err));
            
         },

         assignDeliveryBoy() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "store/order/assign";

            let formData = new FormData();
            formData.append("order_id", this.assign_delivery_boy.order_id);
            formData.append("delivery_boy_id", this.assign_delivery_boy.delivery_boy_id);

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if(response.status == 200) {
                  this.$swal("", response.data.message, "success");        
               }
                  
               this.hideModal('assign-modal');
               this.fetchOrders(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         },
         setBackURL() {
		         localStorage.setItem('back_url', this.active_page_url);
		   },


         async download(order) {
            this.getToken();
            this.order_id = order.id;
            let url = "store/order/online_bill?&id=" + this.order_id;

            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
               responseType: "arraybuffer",
            };
            
            this.getToken();

            this.$axios
            .get(url, config)
            .then((response) => {
               if(response.status == 200) {  

                  let blob = new Blob([response.data], { type: "application/pdf" });
                  // let link = document.createElement("a");
                  // link.href = window.URL.createObjectURL(blob);

                  // //let filename = "bill" + this.bill_date +  ".pdf";
                  // //link.download = filename;

                  // link.target = '_blank';
                  // link.click();

                  var blob_url = window.URL.createObjectURL(blob);
                  let iframe =  document.createElement('iframe'); //load content in an iframe to print later
                  document.body.appendChild(iframe);

                  iframe.style.display = 'none';
                  iframe.src = blob_url;

                  return new Promise(function () { 
                     window.setTimeout(function() {
                        iframe.contentWindow.print();
                     }, 1000)
                  }).then(function () {
                     this.$router.push({ name: 'store.orders'});
                  });            

               } else {
                  this.$swal("", "Something went wrong", "error");
               }
                     
            })

            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
            if(error.response.status == 422) {               
               if (error.response.data) {
                  this.errors = error.response.data.message;
               } 
               this.$swal("", error.response.statusText, "error");
               
            } else if(error.response.status == 500) {
               this.$swal("", error.response.statusText, "error");
            } 
            else if(error.response.status == 401) {
               this.$swal("", error.response.statusText, "error");
               this.$router.push({ name: "login" });
            } else {
               this.$swal("", "Something went wrong", "error");
            }
            } else {
            this.$swal("", error.message, "error");
            }

            });
         },

         cancelOrder(order_id) {

            this.$bvModal.msgBoxConfirm('Are you sure you want to cancel this order?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               if(value){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                 
                  let url = "store/order/cancel";
                  let formData = new FormData();
                  formData.append("order_id", order_id);
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchOrders(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        console.log(error.response);
                        if(error.response.status == 422) {               
                           if (error.response.data) {
                              this.errors = error.response.data.message;
                           } 
                           this.$swal("", error.response.statusText, "error");               
                        } else if(error.response.status == 500) {
                           this.$swal("", error.response.statusText, "error");
                        } else if(error.response.status == 400) {
                           this.$swal("", error.response.data.message, "error");
                        } 
                        else if(error.response.status == 401) {
                           this.$swal("", error.response.statusText, "error");
                           this.$router.push({ name: "login" });
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", error.message, "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },

         timeDiffNow(datetime1, type) {
            //const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
            console.log(datetime1);
            if (datetime1) {
               datetime1 = moment(datetime1, 'YYYY-MM-DDTHH:mm:ssZZ');
               var datetime2 = moment();
               var diff;
             
               diff = datetime2.diff(datetime1, type);
               //var duration = moment.duration(diff);

               console.log(datetime1.format('DD MMM YYYY, hh:mm A') + ',' + datetime2.format('DD MMM YYYY, hh:mm A') + ',' + diff + type);

               return diff;
            }
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                 <!--  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'orders.add' }" class="btn btn-primary float-end">Create Order</router-link>
                     </div>
                  </div>
                  --> <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchOrders()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchOrders()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchOrders()">    
                                 <option value="">All</option>        
                                 <option value="1">Pending</option>
                                 <option value="2">Assigned</option>
                                 <option value="3">In Progress</option>
                                 <option value="4">Delivered</option> 
                                 <option value="5">Cancelled</option>   
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Order ID</th>   
                              <th>Customer</th>
                              <!-- <th>Type</th> -->
                              <th>Payment</th>
                              <th>Total</th>
                              <th>Status</th>
                              <th>Orderd On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody  v-if="Boolean(orders.length)">
                           <tr v-for="(order) in orders" :key="order.id">
                              <td>#{{order.id}}</td>
                              <td>
                                 <span v-if="order.customer_id">

                                 {{order.user_name}}<br>
                                 {{order.user_country_code}} {{order.user_mobile}}<br>
                                 {{order.email}}

                                 </span>
                                 <span v-else-if="order.customer_name">
                                       {{order.customer_name}}<br>
                                       {{order.customer_country_code}} {{order.mobile}}<br>
                                       
                                    </span>
                                    <span v-else>
                                       Guest
                                    </span>
                              
                              </td> 
                              <!-- <td><span v-if="order.customer_type==1">Online</span>
                                 <span v-else>Store</span></td>  -->
                              <td><span v-if="order.payment_type==1">Online</span>
                                          <span v-else>Cash</span></td>
                              <td>Rs.{{order.total}}</td>
                              <td>
                                 <span class="badge rounded-pill bg-primary" v-if="order.status==1">Pending</span>
                                 <span class="badge rounded-pill bg-primary" v-if="order.status==2">Assigned</span>
                                 <span class="badge rounded-pill bg-primary" v-if="order.status==3">In Progress</span>
                                 <span class="badge rounded-pill bg-success" v-if="order.status==4">Delivered</span>
                                 <span class="badge rounded-pill bg-danger" v-if="order.status==5">Cancelled</span>
                                 <p v-if="order.payment_type==1"> <span v-if="order.status==5"><span v-if="order.refund==1">Refund: Yes</span>
                                                               <span v-else>Refund: No</span></span></p>
                                 
                              </td>
                              <td>{{order.converted_created_at}}</td>
                               <td>
                                 <router-link :to="{ name: 'orders.details' , params: {id: order.id} }" class="btn btn-primary me-2 mb-2 btn-sm" @click.native="setBackURL()">Order Details</router-link>

                                 <b-button v-if="order.status==1" variant="primary" class="btn btn-sm me-2 mb-2" @click="fetchDeliveryBoys(order)">Assign Delivery Boy</b-button>

                                 <b-button v-if="order.status != 5 && timeDiffNow(order.created_at, 'hours') <= 24 " variant="danger" class="btn btn-sm me-2 mb-2" @click="cancelOrder(order.id)">Cancel</b-button>
                                 
                                 <button class="btn btn-primary me-2 mb-2 btn-sm" type="button"   @click="download(order)">Print Bill</button>
                              </td>
                             
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="3" class="text-center">No Orders found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                 <!----pagination starts ---> 
                 <caption v-if="Boolean(orders.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchOrders(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>

       <!---- modal starts ---->
      <b-modal ref="assign-modal" id="assign-modal" title="Assign Delivery Boy" hide-footer>
         <b-form @submit.prevent="assignDeliveryBoy()">
            <b-row>                          

               <b-col md="12" class="form-group">
                  <label class="control-label">Delivery Boy<span class="text-danger">*</span></label>
                  <select class="form-control" v-model="assign_delivery_boy.delivery_boy_id">
                     <option value="">Select</option>
                     <option :value="delivery_boy.id" v-for="delivery_boy in delivery_boys" :key="delivery_boy.id">{{delivery_boy.name}}</option>
                  </select>
                  
               </b-col>                           
                           
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('assign-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

     </Layout>
</template>
